module.exports = __webpack_public_path__ + "static/media/children.c9d6144e.svg";